import { Drawer } from '@mantine/core'
import DrawerClasses from './styles.module.css'
import '../../styles/variables.css'

export default Drawer.extend({
    defaultProps: {
        withCloseButton: true,
        padding: 'var(--gm-drawer-padding)',
        // The icon-only close button needs a name; a caller's closeButtonProps replaces this one.
        closeButtonProps: { 'aria-label': 'Close' },
    },
    classNames: DrawerClasses,
})
